const getApiUrl = () => {
    if (window.location.hostname.includes("octosoft.com.br")) {
        return "https://painel.octosoft.com.br/api";
    }
    return process.env.REACT_APP_API_URL || "https://api.fazpedido.com.br";
};

export const apiUrl = getApiUrl();